export const Gifting = {
    // Gift Wrap
    addGiftWrap: 'gift_wrap_add',
    wrapAllTogether: 'gift_wrap_all_together',
    wrapAllIndividually: 'gift_wrap_all_individually',
    noGiftWrap: 'gift_wrap_no_wrap'
};
